/**
 * The groups of Admin → Patient messages' sub-menu, in menu order. Each is `?section=<key>` on
 * /admin/patient-messages; Sending is the page without one. The first three are one settings
 * form (one **Save settings**); Wording publishes each message on its own.
 */
export const PATIENT_MESSAGES_SECTIONS = ["sending", "reminders", "documents", "wording"] as const;

export type PatientMessagesSection = (typeof PATIENT_MESSAGES_SECTIONS)[number];

/** The groups the settings form's cards are in. */
export type PatientMessagesSettingsSection = Exclude<PatientMessagesSection, "wording">;

export const DEFAULT_PATIENT_MESSAGES_SECTION: PatientMessagesSection = "sending";

export const PATIENT_MESSAGES_SECTION_LABELS: Readonly<Record<PatientMessagesSection, string>> = {
  sending: "Sending",
  reminders: "Reminders",
  documents: "Documents",
  wording: "Wording",
};

export function isPatientMessagesSection(value: unknown): value is PatientMessagesSection {
  return (
    typeof value === "string" && (PATIENT_MESSAGES_SECTIONS as readonly string[]).includes(value)
  );
}

/** The route's search: a known section, or none (Sending). */
export function validatePatientMessagesSearch(search: Record<string, unknown>): {
  section?: PatientMessagesSection;
} {
  return isPatientMessagesSection(search.section) ? { section: search.section } : {};
}

/** The search for a section: Sending keeps the plain address. */
export function patientMessagesSearch(section: PatientMessagesSection): {
  section?: PatientMessagesSection;
} {
  return section === DEFAULT_PATIENT_MESSAGES_SECTION ? {} : { section };
}

export function patientMessagesHref(section: PatientMessagesSection): string {
  return section === DEFAULT_PATIENT_MESSAGES_SECTION
    ? "/admin/patient-messages"
    : `/admin/patient-messages?section=${section}`;
}
